import pro1 from "../assets/project1.png";
import pro2 from "../assets/project2.png";
import pro3 from "../assets/project3.png";
const ProjectCardData=[
    {
        imgsrc:pro1,
        title:"Ecommerce website",
        text:"designed an eccommerce website.It contains the features like user authentication.we can place orders,return them.",
        view:"http://saleseeker.free.nf/",
    },
    {
        imgsrc:pro2,
        title:"Weather app",
        text:"designed an eccommerce website.It contains the features like user authentication.we can place orders,return them.",
        view:"https://weatherapp-sand-eight.vercel.app/",
    },
    {
        imgsrc:pro3,
        title:"Stopwatch",
        text:"designed an eccommerce website.It contains the features like user authentication.we can place orders,return them.",
        view:"",
    },
]
export default ProjectCardData;